/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    notifications: {
        menu: {
            index: 'اعلان‌ها',
            create: 'اعلان جدید',
            list: 'اعلان‌ها'
        },
        table_titles: {
            id: 'شناسه',
            type: 'نوع',
            user: 'کاربر',
            data: 'داده',
            read_at: 'زمان خواندن',
            created_at: 'زمان ایجاد',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش اعلان'
    }
}

